// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"2910304f","129":"2fc4abb8","235":"2fc4abb8","352":"4f793d0c","572":"2910304f","754":"e5c3d9ca","839":"d97a177b"}[chunkId] + ".chunk.css";
};